import { BidPoint, Map as SharedMap } from "components/map/shared";
import { bidPointTypesEnum } from "helpers/enums";
import { planLineStyle } from "helpers/map";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Polyline, ZoomControl } from "react-leaflet";
import AxisLoadPoint from "./axisLoadPoint";
import CarStopPoint from "./carStopPoint";
import DriverShiftPoint from "./driverShiftPoint";
import RouteEventPoint from "./routeEventPoint";
import ServiceWorkPoint from "./serviceWorkPoint";
import TemperatureValuePoint from "./temperatureValuePoint";

export default function TaskMap(props) {
    const [viewport, setViewport] = useState({ zoom: 8, center: [55.7473, 52.4568] });

    const map = useRef();
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const { bid, driverShift, temperatureValue } = props.data;
            const points = bid?.bidPoints.map((point) => [point.geozone.location[1], point.geozone.location[0]]) || [];
            if (driverShift?.point?.location) {
                points.push([driverShift.point.location[1], driverShift.point.location[0]]);
            }
            if (temperatureValue?.location) {
                points.push([temperatureValue.location[1], temperatureValue.location[0]]);
            }
            if (points.length > 0) {
                map.current?.fitBounds(points, { maxZoom: 10 });
            }
        }, 300);
        return () => clearTimeout(timeoutId);
    }, []);
    const planRoute = useMemo(() => {
        return (props.data.bid?.route?.segments || []).map((segment) =>
            segment.points.map((point) => [point[1], point[0]]),
        );
    }, []);
    const firstLoadPointIndex = useMemo(() => {
        return props.data.bid?.bidPoints.findIndex((item) =>
            [bidPointTypesEnum.LoadPoint, bidPointTypesEnum.UnloadPoint].includes(item.type),
        );
    }, [props.data.bid?.bidPoints]);

    if (!props.data.bid && !props.data.driverShift?.point?.location && !props.data.temperatureValue?.location) {
        return null;
    }

    return (
        <div className="card card-body mb-4 font-size-14">
            <SharedMap
                ref={map}
                className="vh-50"
                tileUrls={props.tileUrls}
                maxZoom={18}
                viewport={viewport}
                onViewportChanged={setViewport}
                zoomControl={false}
            >
                <Polyline positions={planRoute} {...planLineStyle} />
                {props.data.bid?.bidPoints.map((point, i) => (
                    <BidPoint
                        key={point.id}
                        index={i}
                        item={point}
                        bid={props.data.bid}
                        firstLoadPointIndex={firstLoadPointIndex}
                    />
                ))}
                <ServiceWorkPoint point={props.data.serviceWork?.point} serviceWork={props.data.serviceWork} />
                {props.data.serviceWork?.points?.map((point, i) => (
                    <ServiceWorkPoint key={i} point={point} serviceWork={props.data.serviceWork} />
                ))}
                <DriverShiftPoint driverShift={props.data.driverShift} />
                <AxisLoadPoint axisLoadValue={props.data.axisLoadValue} />
                <CarStopPoint carStop={props.data.carStop} />
                <RouteEventPoint routeEvent={props.data.routeEvent} />
                <TemperatureValuePoint temperatureValue={props.data.temperatureValue} />
                <ZoomControl position="bottomright" />
            </SharedMap>
        </div>
    );
}
